import Feature from "./Feature";

export default class User {
	id: string;
	AccID: number;
	username: string;
	registered: string;
	last_login: string;
	Vorname: string;
	Nachname: string;
	email: string;
	isNotificationReceiver: boolean;
	instagramAccessToken: string;
	token: string;
	features: Array<Feature>;

	constructor(
		id: string,
		AccID: number,
		username: string,
		registered: string,
		last_login: string,
		Vorname: string,
		Nachname: string,
		email: string,
		isNotificationReceiver: boolean,
		instagramAccessToken: string,
		token: string,
		features?: Array<Feature>
	) {
		this.id = id;
		this.AccID = AccID;
		this.username = username;
		this.registered = registered;
		this.last_login = last_login;
		this.Vorname = Vorname;
		this.Nachname = Nachname;
		this.email = email;
		this.isNotificationReceiver = isNotificationReceiver;
		this.instagramAccessToken = instagramAccessToken;
		this.token = token;
		this.features = features || [];
	}

	static emptyUser(): User {
		return new User("", 0, "", "", "", "", "", "", false, "", "");
	}

	clone() {
		const featureList = new Array<Feature>();

		if (this.features) {
			this.features.forEach((feature) => {
				featureList.push(feature.clone());
			});
		}

		return new User(
			this.id,
			this.AccID,
			this.username,
			this.registered,
			this.last_login,
			this.Vorname,
			this.Nachname,
			this.email,
			this.isNotificationReceiver,
			this.instagramAccessToken,
			this.token,
			featureList
		);
	}

	setFeatureList(obj: any[]) {
		obj.forEach(
			(feature: {
				description: string;
				enabled: boolean;
				featureId: string;
				featureType: string;
				initialPrice: number;
				name: string;
				pricePerMonth: number;
			}) => {
				this.features.push(Feature.fromObject(feature));
			}
		);
	}

	static fromObject(obj: {
		AccID: number;
		Nachname: string;
		Vorname: string;
		email: string;
		id: string;
		instagramAccessToken: string;
		isNotificationReceiver: number;
		last_login: string;
		organisation: string | null;
		registered: string;
		token: string;
		username: string;
		features: [];
	}): User {
		const featureList: Feature[] = [];

		if (obj.features) {
			obj.features.forEach((feature) => {
				featureList.push(Feature.fromObject(feature));
			});
		}

		return new User(
			obj.id,
			obj.AccID,
			obj.username,
			obj.registered,
			obj.last_login,
			obj.Vorname,
			obj.Nachname,
			obj.email,
			!!obj.isNotificationReceiver,
			obj.instagramAccessToken,
			obj.token,
			featureList
		);
	}
}
